<div class="w-full px-6 py-8 space-y-10">
    <form [formGroup]="invoiceForm" (ngSubmit)="onSubmit()" class="p-4" class="space-y-10">
        <div class="bg-white rounded-2xl shadow-lg p-6 space-y-6">
            <div class="flex items-center gap-2 border-b pb-2">
                <div class="w-[4px] h-6 bg-primary"></div>
                <h2 class="text-xl font-semibold text-gray-800">Invoice</h2>
            </div>
            <div class="user-group grid grid-cols-12  pt-4 px-6 gap-8">
                <div class="col-span-6">
                    <mat-label>Invoice Number</mat-label>

                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput formControlName="invoiceNumber" />
                    </mat-form-field>
                </div>
                <div class="col-span-6">
                    <mat-label>Type</mat-label>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-select formControlName="type">
                            <mat-option value="Partial">Partial</mat-option>
                            <mat-option value="Final">Final</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-span-6">
                    <mat-label>Date</mat-label>

                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput [matDatepicker]="picker" formControlName="date" />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-span-6">
                    <mat-label>Amount</mat-label>

                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput type="number" formControlName="amount" />
                    </mat-form-field>
                </div>
                <div class="col-span-4">
                    <mat-label>Currency</mat-label>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-select formControlName="currency">
                            <mat-option value="INR">INR</mat-option>
                            <mat-option value="USD">USD</mat-option>
                            <mat-option value="EUR">EUR</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                 <div class="col-span-4">
                    <mat-label>GST</mat-label>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-select formControlName="gst">
                            <mat-option value="0">0</mat-option>
                            <mat-option value="2.5">2.5</mat-option>
                            <mat-option value="5">5</mat-option>
                             <mat-option value="10">10</mat-option>
                            <mat-option value="12">12</mat-option>
                            <mat-option value="18">18</mat-option>
                            <mat-option value="20">20</mat-option>
                            <mat-option value="28">28</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-span-4">
                    <mat-label>Status</mat-label>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-select formControlName="status">
                            <mat-option value="Pending">Pending</mat-option>
                            <mat-option value="Paid">Paid</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-span-12">
                    <mat-label>Description</mat-label>

                    <mat-form-field appearance="outline" class="full-width">
                        <textarea matInput formControlName="description"></textarea>
                    </mat-form-field>
                </div>

            </div>

            <button mat-raised-button color="primary" type="submit">Submit</button>
        </div>
    </form>
</div>